import React, { useEffect, useState } from "react";
import { Redirect } from "react-router";
import { makeStyles } from "@material-ui/core/styles";

import Wrapper from "src/components/Wrapper";
import AdminHtml from "src/layouts/AdminHtml";

import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { updateUserApi } from "src/apiService";
import { useSelector } from "react-redux";
import {
  userGetStartedStepSelector,
  userSetupQuestionsSelector,
} from "src/store/system/selector";
import OnboardingContent from "src/pages/GetStarted/Onboarding/OnboardingContent";
import { Grow } from "@material-ui/core";
import SetupProgress from "src/pages/GetStarted/Onboarding/SetupProgress";
import { type Theme } from "src/theme";
import HideSetupPageButton from "src/components/Onboarding/HideSetupPageButton";
import Content from "src/pages/GetStarted/LegacyWizard/Content";
import type Step from "src/pages/GetStarted/Step";

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    display: "flex",
    flexDirection: "column",
  },
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: 1,
    padding: theme.spacing(8),
  },
  button: {
    marginTop: theme.spacing(4),
    padding: theme.spacing(1.5, 4),
    width: 200,
    marginBottom: theme.spacing(8),
  },
  greeting: {
    fontSize: theme.typography.h6.fontSize,
    textAlign: "center",
    marginBottom: theme.spacing(1),
  },
  onboardingContent: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    overflowY: "auto",
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

const COMPLETED_STEPS: Step[] = [
  "bulk-edit:instructions",
  "bulk-edit:have-you-finished",
  "complete-set-up",
];
const OLD_WIZARD_STEPS: Step[] = [
  "other:do-you-sell",
  "other:upload",
  "other:do-you-have-additional",
  "plaid:would-you-like-to-connect",
  "plaid:add-new",
  "expenses:do-you-have-other",
  "expenses:do-you-have-more",
];

function GetStarted() {
  const classes = useStyles();
  const [showContent, setShowContent] = useState(false);
  const step = useSelector(userGetStartedStepSelector);
  const setupQuestions = useSelector(userSetupQuestionsSelector);
  const hasStarted =
    step && step !== "inventory:how-do-you-account-for-your-inventory";
  const isEffectivelyComplete =
    !setupQuestions && !!step && COMPLETED_STEPS.includes(step);
  const isOldWizardUser =
    !setupQuestions && !!step && OLD_WIZARD_STEPS.includes(step);

  useEffect(() => {
    if (isEffectivelyComplete) {
      updateUserApi({ getStartedStep: "complete-set-up" });
    }
  }, [isEffectivelyComplete]);

  if (isEffectivelyComplete) {
    return <Redirect to="/management" />;
  }

  if (isOldWizardUser) {
    return (
      <AdminHtml
        pageTitle="Get Started"
        pageDescription="Let's set up your Genie"
      >
        <Wrapper className={classes.wrapper}>
          <Content />
        </Wrapper>
      </AdminHtml>
    );
  }

  return (
    <AdminHtml
      pageTitle="Get Started"
      pageDescription="Let's set up your Genie"
    >
      <Wrapper className={classes.wrapper}>
        {!setupQuestions ? (
          <>
            {" "}
            {!showContent ? (
              <Paper className={classes.root}>
                <Typography className={classes.greeting}>
                  Ready to add some {String.fromCodePoint(0x1f680)} fuel to your
                  business?
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  onClick={() => {
                    if (!hasStarted)
                      updateUserApi({ getStartedStart: new Date() });
                    setShowContent(true);
                  }}
                >
                  Launch Setup
                </Button>
                {step && <HideSetupPageButton />}
              </Paper>
            ) : (
              <Paper className="h-full">
                <Grow
                  in={showContent}
                  style={{ transformOrigin: "50% 100% 0" }}
                  {...(showContent ? { timeout: 1000 } : {})}
                >
                  <div className={classes.onboardingContent}>
                    <OnboardingContent onClose={() => setShowContent(false)} />
                  </div>
                </Grow>
              </Paper>
            )}
          </>
        ) : (
          <Paper className={classes.root}>
            <SetupProgress />
          </Paper>
        )}
      </Wrapper>
    </AdminHtml>
  );
}
export default GetStarted;
